import {useStoreMobx} from "@/shared/lib/mobx/useStoreMobx";

export const useCatalogShowMore = () => {
    const {catalogStore} = useStoreMobx();

    const hasMore = catalogStore.activePage < Math.ceil(catalogStore.catalogCount / catalogStore.perPageStart);

    return {
        hasMore,
        loading: catalogStore.loaderShowBtn,
        showMore: catalogStore.showMore,
    };
};
